module.exports = __webpack_public_path__ + "static/media/laptop_two.82e3798f.png";